import { FocusDto } from '../../coaching-base/general';
import { ObservationSummaryContainerView } from '../../coaching-detail';
import { createAction } from '../../store.model';

export enum ActionType {
    COACHING_OBSERVATION_REVIEW__RELOAD = 'COACHING_OBSERVATION_REVIEW__RELOAD',
    COACHING_OBSERVATION_REVIEW__GO_TO_OBSERVATION = 'COACHING_OBSERVATION_REVIEW__GO_TO_OBSERVATION',
    COACHING_OBSERVATION_REVIEW__SET_IN_REVIEW = 'COACHING_OBSERVATION_REVIEW__SET_IN_REVIEW',
    COACHING_OBSERVATION_REVIEW__PREV_OBSERVATION = 'COACHING_OBSERVATION_REVIEW__PREV_OBSERVATION',
    COACHING_OBSERVATION_REVIEW__NEXT_OBSERVATION = 'COACHING_OBSERVATION_REVIEW__NEXT_OBSERVATION',
}

export interface ReloadAction {
    observations: ObservationSummaryContainerView[];
    observationId?: number;
    inReview?: boolean;
    focus?: FocusDto;
    force?: boolean;
}

export const reload = createAction<ActionType, ReloadAction>(
    ActionType.COACHING_OBSERVATION_REVIEW__RELOAD,
);

/// //////////////////////

export interface GoToObservationAction {
    observationId: number;
}

export const goToObservation = createAction<ActionType, GoToObservationAction>(
    ActionType.COACHING_OBSERVATION_REVIEW__GO_TO_OBSERVATION,
);

/// //////////////////////

export interface SetInReviewAction {
    inReview?: boolean;
}

export const setInReview = createAction<ActionType, SetInReviewAction>(
    ActionType.COACHING_OBSERVATION_REVIEW__SET_IN_REVIEW,
);

/// //////////////////////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PrevObservationAction {}

export const prevObservation = createAction<ActionType, PrevObservationAction>(
    ActionType.COACHING_OBSERVATION_REVIEW__PREV_OBSERVATION,
);

/// //////////////////////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface NextObservationAction {}

export const nextObservation = createAction<ActionType, NextObservationAction>(
    ActionType.COACHING_OBSERVATION_REVIEW__NEXT_OBSERVATION,
);
